import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';

const Header = () => {
  const navigate = useNavigate();
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  const scrollToSection = (sectionId) => {
    navigate('/');
    setMobileMenuOpen(false);

    setTimeout(() => {
      const element = document.getElementById(sectionId);
      if (element) {
        element.scrollIntoView({ behavior: 'smooth' });
      }
    }, 100);
  };

  return (
    <header className="container site-header">
      <a href="/" className="logo-link">
        <img
          className="logo"
          src={process.env.PUBLIC_URL + '/images/logo/shoptop_logo_3d_icon_transparent.png'}
          alt="SHOPTOP BRANDS"
        />
      </a>

      <button
        className={`burger ${mobileMenuOpen ? 'active' : ''}`}
        onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
        aria-label="Открыть меню"
        type="button"
      >
        <span></span>
        <span></span>
        <span></span>
      </button>

      <div className={`header-right ${mobileMenuOpen ? 'open' : ''}`}>
        <nav className="main-nav">
          <ul>
            <li>
              <button className="menu-link" onClick={() => { navigate('/vilatte'); setMobileMenuOpen(false); }}>
                VILATTE
              </button>
            </li>
            <li>
              <button className="menu-link" onClick={() => scrollToSection('categories')}>
                Что можно заказать
              </button>
            </li>
            <li>
              <button className="menu-link" onClick={() => scrollToSection('about')}>
                Анонсы
              </button>
            </li>
            <li>
              <button className="menu-link" onClick={() => scrollToSection('advantages')}>
                Преимущества
              </button>
            </li>
            <li>
              <button className="menu-link" onClick={() => scrollToSection('rules')}>
                Правила заказа
              </button>
            </li>
          </ul>
        </nav>

        <div className="iconstwo header-socials">
          <a
            className="social-icons header-social-link"
            href="https://t.me/+jvWd_bsS40Y0MmFi"
            target="_blank"
            rel="noreferrer"
            aria-label="Telegram"
          >
            <img
              src={process.env.PUBLIC_URL + '/images/svg/telegram.svg'}
              alt=""
            />
          </a>

          <a
            className="social-icons header-social-link"
            href="https://api.whatsapp.com/send?phone=79130117070"
            target="_blank"
            rel="noreferrer"
            aria-label="WhatsApp"
          >
            <img
              src={process.env.PUBLIC_URL + '/images/svg/whatsapp.svg'}
              alt=""
            />
          </a>

          <a
            className="social-icons header-social-link"
            href="https://max.ru/u/f9LHodD0cOJjibeQdLaN1HkU7twja89JfpuGsU8p2lFu6TOKe4IPrrruCrA"
            target="_blank"
            rel="noreferrer"
            aria-label="MAX"
          >
            <span>MAX</span>
          </a>
        </div>
      </div>
    </header>
  );
};

export default Header;
